import ReactModal from "react-modal";
import "../../components/modal/ModalCss.scss";
import BasicButton from "components/button/BasicButton";
import { sendPost } from "api/restUtil";
import { useEffect, useState } from "react";
import { getNowTimeHmsS, getTodayStr, isEmpty} from "js/common";
import BasicInput from "components/input/BasicInput";
import { getResultMsg } from "js/order";

/**
 * 발송준비중 처리 팝업
 */
function SendReadyModal (props) {

	const { isOpen, modalId, onClose, data, initData } = props;
	const [trackingNumber, setTrackingNumber] = useState("");
	
	useEffect(() => {
		if(!isOpen) setTrackingNumber("");
	}, [isOpen]);

	// 발송 처리(준비중)
	const productOrderSendReady = async () => {

		const productOrderIds = initData.productOrderIds;
		if(productOrderIds == null || productOrderIds.length === 0) {
			alert("발송 처리 가능한 상품주문이 없습니다.");
			return;
		}

		if(isEmpty(trackingNumber)) {
			alert("송장 번호를 입력해 주세요.");
			return;
		}

		
		if(!window.confirm("발송 처리 하시겠습니까?")) return;

		const dispatchDate = getTodayStr() + "T" + getNowTimeHmsS() + "+09:00";
		
		const dispatchProductOrders = productOrderIds.map(d => ({
			productOrderId: d,
			dispatchDate: dispatchDate,
			deliveryMethod: initData.deliveryMethod,
			deliveryCompanyCode: "SNOWFOXFLOWER",
			trackingNumber: trackingNumber,
		}));
		
		const result = await sendPost("/api/order/dispatch", {dispatchProductOrders: dispatchProductOrders});
		if(result.respCode === "SUCCESS") {
			
			if(productOrderIds.length === result.data.data.successProductOrderIds.length) {
				alert("발송 처리 (배송준비중) 되었습니다.");
			} else {
				const msg = getResultMsg(result.data.data);
				alert(msg);
			}
			onClose(result.data.data.successProductOrderIds.length, result.data.data.failProductOrderInfos.length);

		}
	}




	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={"구매확정 팝업"}
			id={modalId}
		>

			<div className="me-modal">
				<div className="me-modal-container" style={{width: "500px", height: "150px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">발송처리</h4>
						</div>
						<div className="me-modal-body" style={{overflowY: "auto", overflowX: "hidden"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="grid-table" style={{gridTemplateColumns: "1fr 4fr"}}>
								<div className="th required">송장번호</div>
								<div className="td">
									<BasicInput item={{}} value={trackingNumber} onChange={(e) => setTrackingNumber(e.target.value)} width="" textAlign="left" />
								</div>
							</div>
						</div>
						<div className="me-modal-footer mg-b-20" style={{marginTop: "auto"}}>
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="취소" className="btn-cancel" onClick={() => onClose(null)} style={{width: "100%"}} />
								<BasicButton label="확인" className="btn-save" onClick={() => productOrderSendReady()} style={{width: "100%"}} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</ReactModal>
	);
}

export default SendReadyModal;
